/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_SubscribeInputs */

const id_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlangganan`)
};

const ms_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langgan`)
};

const da_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonner`)
};

const de_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnieren`)
};

const en_us2_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const es_es2_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse`)
};

const es_mx2_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse`)
};

const fil_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-subscribe`)
};

const fr_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'abonner`)
};

const it_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti`)
};

const hu_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozás`)
};

const nl_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonneren`)
};

const no_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonner`)
};

const pl_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrybuj`)
};

const pt_br2_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const pt_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrever`)
};

const ro_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonare`)
};

const fi_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilaa`)
};

const sv_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumerera`)
};

const vi_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký`)
};

const tr_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone ol`)
};

const cs_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit k odběru`)
};

const bg_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абониране`)
};

const ru_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться`)
};

const uk_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписатися`)
};

const ar_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراك`)
};

const hi_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब करें`)
};

const th_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับ`)
};

const ja_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読`)
};

const zh_cn2_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const zh_hant1_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const ko_notifications_push_subscribe = /** @type {(inputs: Notifications_Push_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Notifications_Push_SubscribeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_subscribe = /** @type {((inputs?: Notifications_Push_SubscribeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_SubscribeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_subscribe(inputs)
	if (locale === "ms") return ms_notifications_push_subscribe(inputs)
	if (locale === "da") return da_notifications_push_subscribe(inputs)
	if (locale === "de") return de_notifications_push_subscribe(inputs)
	if (locale === "en-US") return en_us2_notifications_push_subscribe(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_subscribe(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_subscribe(inputs)
	if (locale === "fil") return fil_notifications_push_subscribe(inputs)
	if (locale === "fr") return fr_notifications_push_subscribe(inputs)
	if (locale === "it") return it_notifications_push_subscribe(inputs)
	if (locale === "hu") return hu_notifications_push_subscribe(inputs)
	if (locale === "nl") return nl_notifications_push_subscribe(inputs)
	if (locale === "no") return no_notifications_push_subscribe(inputs)
	if (locale === "pl") return pl_notifications_push_subscribe(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_subscribe(inputs)
	if (locale === "pt") return pt_notifications_push_subscribe(inputs)
	if (locale === "ro") return ro_notifications_push_subscribe(inputs)
	if (locale === "fi") return fi_notifications_push_subscribe(inputs)
	if (locale === "sv") return sv_notifications_push_subscribe(inputs)
	if (locale === "vi") return vi_notifications_push_subscribe(inputs)
	if (locale === "tr") return tr_notifications_push_subscribe(inputs)
	if (locale === "cs") return cs_notifications_push_subscribe(inputs)
	if (locale === "bg") return bg_notifications_push_subscribe(inputs)
	if (locale === "ru") return ru_notifications_push_subscribe(inputs)
	if (locale === "uk") return uk_notifications_push_subscribe(inputs)
	if (locale === "ar") return ar_notifications_push_subscribe(inputs)
	if (locale === "hi") return hi_notifications_push_subscribe(inputs)
	if (locale === "th") return th_notifications_push_subscribe(inputs)
	if (locale === "ja") return ja_notifications_push_subscribe(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_subscribe(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_subscribe(inputs)
	return ko_notifications_push_subscribe(inputs)
});
export { notifications_push_subscribe as "notifications.push.subscribe" }